// Copyright (c) 2026. Hardfin, Inc. All rights reserved.

interface BlockedReasonInput {
  hasItems: boolean;
  // A unit has to belong to the project somehow. With no inclusion checked the
  // filter describes no population at all.
  hasInclusion: boolean;
  isCountLoading: boolean;
}

/**
 * Why the report cannot be saved yet, or null when it can. The backend refuses
 * every one of these, so answering here is what keeps a validation rejection
 * from reaching the user as an unexplained error.
 */
export function toBlockedReason(input: BlockedReasonInput): string | null {
  if (!input.hasItems) return 'Select at least one SKU';
  if (!input.hasInclusion) {
    return 'Turn on at least one join rule';
  }
  if (input.isCountLoading) return 'Building the chart';
  return null;
}
